if (!customElements.get('wolff-navigation')) {
  customElements.define('wolff-navigation', class extends HTMLElement {
    connectedCallback() {
      this.events = new AbortController();
      this.menus = [...this.querySelectorAll('.wolff-mega')];
      this.desktop = matchMedia('(min-width: 1100px) and (hover: hover) and (pointer: fine)');
      const listen = (target, name, callback) => target.addEventListener(name, callback, {signal:this.events.signal});
      this.querySelectorAll('.wolff-nav__list > li').forEach(item => {
        const menu = item.querySelector('.wolff-mega');
        listen(item, 'pointerenter', event => {
          if (!this.desktop.matches || event.pointerType !== 'mouse') return;
          clearTimeout(this.closeTimer);
          clearTimeout(this.openTimer);
          this.openTimer = setTimeout(() => {
            this.closeAll(menu);
            if (menu) menu.open = true;
          }, 120);
        });
        listen(item, 'pointerleave', () => {
          clearTimeout(this.openTimer);
          this.closeTimer = setTimeout(() => {
            if (!item.matches(':focus-within')) this.closeAll();
          }, 200);
        });
        if (!menu) return;
        listen(menu, 'toggle', () => {
          menu.querySelector('summary').setAttribute('aria-expanded', String(menu.open));
          if (menu.open) this.closeAll(menu);
          this.syncHeader();
        });
        listen(menu.querySelector('summary'), 'click', () => {
          clearTimeout(this.openTimer); clearTimeout(this.closeTimer);
        });
        listen(menu, 'keydown', event => {
          if (event.key !== 'Escape' || !menu.open) return;
          event.preventDefault(); event.stopPropagation();
          this.closeAll();
          menu.querySelector('summary').focus();
        });
      });
      listen(document, 'pointerdown', event => { if (!this.contains(event.target)) this.closeAll(); });
      listen(this, 'focusout', () => queueMicrotask(() => {
        if (!this.contains(document.activeElement)) this.closeAll();
      }));
      listen(this.desktop, 'change', () => this.closeAll());
      listen(document, 'shopify:block:select', event => {
        const menu = event.target.closest('.wolff-mega');
        if (menu && this.contains(menu)) { this.closeAll(menu); menu.open = true; }
      });
      listen(document, 'shopify:block:deselect', event => {
        if (this.contains(event.target)) this.closeAll();
      });
    }
    closeAll(except) {
      clearTimeout(this.openTimer); clearTimeout(this.closeTimer);
      this.menus.forEach(menu => {
        if (menu === except) return;
        menu.open = false;
        menu.querySelector('summary').setAttribute('aria-expanded','false');
      });
      this.syncHeader();
    }
    syncHeader() {
      const header = this.closest('.header-wrapper');
      if (header) header.preventHide = this.menus.some(menu => menu.open);
    }
    disconnectedCallback() {
      this.closeAll();
      this.events?.abort();
    }
  });
}
